import React, { useState } from 'react'

const RangeFilter = ({ onFilter }) => {
    const [min, setMin] = useState('')
    const [max, setMax] = useState('')
    const [error, setError] = useState('')

    const handleGoClick = () => {
        const minVal = parseFloat(min)
        const maxVal = parseFloat(max)

        if (!min || !max) {
            setError('Both minimum and maximum values are required.')
            return
        } else if (!isNaN(minVal) && !isNaN(maxVal) && minVal <= maxVal) {
            onFilter(minVal, maxVal)
            setError('')
        } else {
            setError('Please enter valid numbers. Min should be less than or equal to Max.')
        }
    }

    return (
        <>
            <div style={styles.container}>
                <input
                    type="number"
                    placeholder="Min"
                    value={min}
                    onChange={(e) => setMin(e.target.value)}
                    style={styles.input}
                />
                <span style={styles.hyphen}>-</span>
                <input
                    type="number"
                    placeholder="Max"
                    value={max}
                    onChange={(e) => setMax(e.target.value)}
                    style={styles.input}
                />
                <button onClick={handleGoClick} style={styles.button}>
                    Go
                </button>
            </div>
            {error && (
                <p
                    style={{
                        color: 'red',
                        fontSize: '0.85rem',
                    }}
                >
                    {error}
                </p>
            )}
        </>
    )
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    input: {
        width: '80px',
        padding: '6px',
        fontSize: '14px',
        borderRadius: '4px',
        border: '1px solid #e4e4e4',
    },
    hyphen: {
        fontSize: '16px',
    },
    button: {
        padding: '6px 12px',
        fontSize: '14px',
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
    },
}

export default RangeFilter
